import { Injectable } from '@angular/core';
/**
 * Servicio para manejo del storage del navegador
 */
@Injectable()
export class StorageService {

  /**
   * Inicializa constructor
   * @param localStorageService 
   */
  constructor() { }

  /**
   * Almacena valor en el storage
   * @param key A
   * @param value 
   */
  set(key, value): void {
    localStorage.setItem(key, value);
  }

  /** Obtiene valor del storage */ 
  get(key: string): any {
    return localStorage.getItem(key);
  }

  /**
   * Elimina valor del storage
   * @param key 
   */
  clearKey(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Elimina todos los valores del storage
   * @param key 
   */
  clearAll(): void {
    localStorage.clear()
  }

  safeStringify(_data: any): string {
    const seen = new WeakSet();
    return JSON.stringify(_data, (_key, _value) => {
      if(typeof _value === 'object' && _value !== null) {
        if(seen.has(_value)) return;
        seen.add(_value)
      }
      return _value
    });
  }

}
